import { Component, Input } from '@angular/core';
import { NgbActiveModal, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
import { ModalConfig } from './modal-config';

@Component({
    selector: 'app-modal',
    templateUrl: './modal.component.html',
    styleUrls: ['./modal.component.scss'],
    standalone: false
})
export class ModalComponent {
  @Input() public modalConfig!: ModalConfig;

  constructor(config: NgbModalConfig, private readonly ngbActiveModal: NgbActiveModal) {
    config.backdrop = 'static';
  }

  close() {
    this.ngbActiveModal.close();
  }

  dismiss() {
    this.ngbActiveModal.dismiss();
  }

}
